export const theme = {
  breakpoints: ["576px", "768px", "992px", "1200px", "1400px"],
  grid: {
    container: "130rem",
    gutter: "3.2rem",
  },
  border: {
    radius: "16px",
    xradius: "24px",
    xsmallRadius: "4px",
    smallRadius: "8px",
    normal: "10px",
    mediumRadius: "16px",
    largeRadius: "32px",
  },
  font: {
    roboto:
      "Roboto, -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
    montserrat: "Montserrat, sans-serif",
    comfortaa: "Comfortaa, cursive",
    poppins: "Poppins, sans-serif",
    sora: "Sora",
    inter: "Inter, sans-serif",
    workSans: "Work Sans, sans-serif",
    light: 300,
    normal: 400,
    semiBold: 500,
    bold: 600,
    xbold: 700,
    medium: 500,
    sizes: {
      xxxsmall: "0.875rem",
      xxsmall: "1.125rem",
      xsmall: "1.2rem",
      small: "1.4rem",
      medium: "1.5rem",
      large: "1.8rem",
      xlarge: "2.2rem",
      xxlarge: "2.5rem",
      huge: "4.6rem",
      normal: "1rem",
    },
  },
  colors: {
    primary: "#0C7488",
    secondary: "#00995D",
    mainBg: "##F2F2F2",
    white: "#fff",
    lightGray: "#BDBDBD",
    gray: "#8F8F8F",
    darkGray: "#6f6f6e",
    black: "#42425D",
    red: "#EB5757",
    green: "#00C247",
    lightBlue: "#91DBE4",
    lightGray5: "#E0E0E0",
    lightGray6: "#F2F2F2",
    blue: "#004CE8",
    darkBlue: "#03091D",
    green1: "#046639",
    green2: "#0E9658",
    green3: "#66BC51",
    green4: "#45A752",
    green5: "#B4E08E",
    erro: "#FF3333",
    gray50: "#FAFAFA",
    gray100: "#F5F5F5",
    gray200: "#EEEEEE",
    gray300: "#E0E0E0",
    gray400: "#BDBDBD",
    gray500: "#9E9E9E",
    gray600: "#757575",
    gray700: "#616161",
    gray800: "#424242",
    gray900: "#212121",
    gray2: "#AAB8C2",
    system: "#004CE8",
    blue900: "#0E1428",
    blue800: "#040B22",
    blue400: "#0C7488",
    blue100: "#92DCE5",
    overlay: {
      primary: "rgba(0,0,0,.4)",
    },
  },
  transition: {
    default: "0.2s ease-in-out",
    fast: "0.1s ease-in-out",
  },
};
